import FastImage from "../../../../globals/elements/fastimg";

function TeamDetailPage() {
    return (
        <>
            {/* Team Detail */}
            <div className="section-full p-t80 p-b50 bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12">
                            <div className="mt-team-seven m-b20 bg-gray">
                                <div className="mt-team-media">
                                    <FastImage src="images/our-team5/p1.jpg" className="" alt="" />
                                </div>
                                <div className="mt-team-info text-center p-a20 bg-white">
                                    <h4 className="mt-team-title m-t0">Joe Johnson</h4>
                                    <p>Co-Founder</p>
                                    <div className="social-share-btn-content">
                                        <ul className="social-icons social-square">
                                            <li><a href="https://www.facebook.com/" className="fa fa-facebook" /></li>
                                            <li><a href="https://twitter.com/" className="fa fa-twitter" /></li>
                                            <li><a href="https://in.linkedin.com/" className="fa fa-linkedin" /></li>
                                            <li><a href="https://rss.com/" className="fa fa-rss" /></li>
                                            <li><a href="https://www.youtube.com/" className="fa fa-youtube" /></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <div className="bg-white">
                                <div className="p-b30">
                                    <div className="mt-box">
                                        <h2 className="m-t0">Our Skills</h2>
                                    </div>
                                    <div className="our-exp">
                                        <span className="progressText text-black"><b>Collaboration</b></span>
                                        <div className="progress m-b30 m-t10">
                                            <div className="progress-bar site-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '85%' }} aria-valuenow={85} aria-valuemin={0} aria-valuemax={100}>85%</div>
                                        </div>
                                        <span className="progressText text-black"><b>Customer Service</b></span>
                                        <div className="progress m-b30 m-t10">
                                            <div className="progress-bar site-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '78%' }} aria-valuenow={78} aria-valuemin={0} aria-valuemax={100}>78%</div>
                                        </div>
                                        <span className="progressText text-black"><b>Positive Attitude</b></span>
                                        <div className="progress m-b30 m-t10">
                                            <div className="progress-bar site-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '80%' }} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100}>80%</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 col-sm-12">
                                        <div className="mt-icon-box-wraper left    p-a10 m-b30 clearfix bdr-1 bdr-solid bdr-gray">
                                            <div className="icon-sm">
                                                <span className="iconmoon-travel site-text-primary" />
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte m-b0">Experience </h4>
                                                <span className="display-block">12 Year</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-12">
                                        <div className="mt-icon-box-wraper left  p-a10 m-b30 clearfix bdr-1 bdr-solid bdr-gray">
                                            <div className="icon-sm">
                                                <span className="iconmoon-smartphone-1 site-text-primary" />
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte m-b0">Contact</h4>
                                                <span className="display-block">+41 555 888 9585</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-12">
                                        <div className="mt-icon-box-wraper left  p-a10 m-b30 clearfix bdr-1 bdr-solid bdr-gray">
                                            <div className="icon-sm">
                                                <span className="iconmoon-email site-text-primary" />
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte m-b0">Email</h4>
                                                <span className="display-block">info@demo.com</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Team Member Info */}
            <div className="section-full p-b80">
                <div className="container">
                    <div className="section-content">
                        <div className="mt-info mt-team-full-info">
                            <h4>About Me</h4>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                dummy text of the printing and typesetting industry.
                            </p>
                            <p>
                                when an unknown printer took a galley of type and scrambled it to make a type specimen book. dummy text of the printing and typesetting industry. Phasellus in risus quis lectus iaculis vulputate id quis nisl.
                            </p>
                        </div>
                        <div className="mt-info mt-team-full-info">
                            <h4>Experience</h4>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                dummy text of the printing and typesetting industry.
                            </p>
                            <p>
                                when an unknown printer took a galley of type and scrambled it to make a type specimen book. dummy text of the printing and typesetting industry. Phasellus in risus quis lectus iaculis vulputate id quis nisl.
                            </p>
                            <ul className="list-check primary m-b0">
                                <li>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.</li>
                                <li>Phasellus in risus quis lectus iaculis vulputate id quis nisl.</li>
                                <li>Amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TeamDetailPage;